import axios from 'axios'

export default {
  createUpdateDiscount (discount) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts', discount).then((response) => {
      return response
    })
  },
  getDiscounts () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts/').then((response) => {
      return response
    })
  },
  getDiscountsForCustomer (customerId) {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts/' + customerId).then((response) => {
      return response
    })
  },
  createUpdateCustomerSpecificPrices (prices) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts/prices', prices).then((response) => {
      return response
    })
  },
  getPricesForCustomer (customerId) {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts/prices/' + customerId).then((response) => {
      return response
    })
  },
  getPricesForCustomerOnAuth () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/discounts/prices').then((response) => {
      return response
    })
  }
}
